import React, { useContext, useEffect, useState } from 'react';
import SubscriptionItem from './SubscriptionItem/SubscriptionItem';
import APIClient from '../../helpers/APIClient';
import Styles from './SubscriptionList.module.scss';
import localization from '../../data/localization/en-US.json';
import { subscriptionContext } from '../../context/subscriptionContext';
import { sortSubscriptionList } from '../../helpers/util/utils';

const SubscriptionList = (props) => {
  const { toggleModal } = props;
  const subscriptions = useContext(subscriptionContext);
  const { state, dispatch } = subscriptions;
  const { data, globallySuppressed } = state;
  const [serviceDown, setServiceDown] = useState(false);

  const getSubscriptions = () => {
    APIClient.getSubscriptions((status, res) => {
      if (status === 200 && res.data) {
        dispatch({
          type: 'SET_SUBSCRIPTIONS',
          data: res.data,
          globallySuppressed: res?.data?.global?.suppressed ?? null,
        });
      } else {
        setServiceDown(true);
      }
    });
  };

  const scrollToTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  useEffect(() => {
    if (!data) {
      getSubscriptions();
    }
  }, [data]);

  return (
    <div>
      <div className={Styles.tileHeader}>
        {localization.subscriptionHeaderText}
        {(!serviceDown || data) && (
          <button
            type='button'
            onClick={() => {
              toggleModal();
              scrollToTop();
            }}
            className={Styles.editBtn}
          >
            {localization.editText}
          </button>
        )}
      </div>
      {
        serviceDown ? (
          <div className={Styles.serviceDown}>{localization.serviceDown}</div>
        ) : (
          <div className={Styles.list}>
            {data?.groups
              && sortSubscriptionList(data.groups).map((item) => {
                return (
                  <div key={`${item.name?.replace(' ', '')}-${item.id}`}>
                    <SubscriptionItem
                      item={item}
                      isEditing={false}
                      globallySuppressed={globallySuppressed}
                    />
                  </div>
                );
              })
            }
          </div>
        )
      }
    </div>
  );
};

export default SubscriptionList;
